import { application } from './application';

// External

import { Dropdown, Toggle, Slideover } from 'tailwindcss-stimulus-components';
import Carousel from 'stimulus-carousel';

application.register('dropdown', Dropdown);
application.register('toggle', Toggle);
application.register('slideover', Slideover);
application.register('carousel', Carousel);

// Global
import AspectsController from './aspects_controller';
application.register('aspects', AspectsController);

import ThemeController from './theme_controller';
application.register('theme', ThemeController);

import NestedFormController from './nested_form_controller';
application.register('nested-form', NestedFormController);

import IntroNewsTimerController from './intro_news_timer_controller';
application.register('intro-news-timer', IntroNewsTimerController);

import ChatController from './chat_controller';
application.register('chat', ChatController);

import ChatTaxonomyValidatorController from './chat_taxonomy_validator_controller';
application.register('chat-taxonomy-validator', ChatTaxonomyValidatorController);

import ChatTaxonomyBulkUploadController from './chat_taxonomy_bulk_upload_controller';
application.register('chat-taxonomy-bulk-upload', ChatTaxonomyBulkUploadController);

import ChatTaxonomyInlineSaveController from './chat_taxonomy_inline_save_controller';
application.register('chat-taxonomy-inline-save', ChatTaxonomyInlineSaveController);

import ChatDocumentPreviewController from './chat_document_preview_controller';
application.register('chat-document-preview', ChatDocumentPreviewController);

import ColorizerController from './colorizer_controller';
application.register('colorizer', ColorizerController);

import AutoSubmitController from './auto_submit_controller';
application.register('auto-submit', AutoSubmitController);

import CompareController from './compare_controller';
application.register('compare', CompareController);

import CsvController from './csv_controller';
application.register('csv', CsvController);

import FormsController from './forms_controller';
application.register('forms', FormsController);

import GoodDaysController from './good_days_controller';
application.register('good-days', GoodDaysController);

import IconsController from './icons_controller';
application.register('icons', IconsController);

import FamilyTreeController from './family_tree_controller';
application.register('family-tree', FamilyTreeController);

import InternalWikiController from './internal_wiki_controller';
application.register('internal-wiki', InternalWikiController);

import LifeCycleChartsController from './life_cycle_charts_controller';
application.register('life-cycle-charts', LifeCycleChartsController);

import LinksController from './links_controller';
application.register('links', LinksController);

import MapsController from './maps_controller';
application.register('maps', MapsController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import PasswordRevealController from './password_reveal_controller';
application.register('password-reveal', PasswordRevealController);

import PlacesAutocompleteController from './places_autocomplete_controller';
application.register('places-autocomplete', PlacesAutocompleteController);

import Power10ChartsController from './power10_charts_controller';
application.register('power10-charts', Power10ChartsController);

import PowerChartsController from './power_charts_controller';
application.register('power-charts', PowerChartsController);

import CastReloadController from './cast_reload_controller';
application.register('cast-reload', CastReloadController);

import ResetController from './reset_controller';
application.register('reset', ResetController);

import ScrollController from './scroll_controller';
application.register('scroll', ScrollController);

import SearchController from './search_controller';
application.register('search', SearchController);

import SignupController from './signup_controller';
application.register('signup', SignupController);

import SortController from './sort_controller';
application.register('sort', SortController);

import SystemsController from './systems_controller';
application.register('systems', SystemsController);

import TabsController from './tabs_controller';
application.register('tabs', TabsController);

import TimeController from './time_controller';
application.register('time', TimeController);

import TimeOfBirthController from './time_of_birth_controller';
application.register('time-of-birth', TimeOfBirthController);

import ToggleController from './toggle_controller';
application.register('toggle', ToggleController);

import TooltipsController from './tooltips_controller';
application.register('tooltips', TooltipsController);

import TourDashboardController from './tour_dashboard_controller';
application.register('tour-dashboard', TourDashboardController);

import TourNatalChartController from './tour_natal_chart_controller';
application.register('tour-natal-chart', TourNatalChartController);

import TourProfessionalSelfController from './tour_professional_self_controller';
application.register('tour-professional-self', TourProfessionalSelfController);

import TourRomanticSelfController from './tour_romantic_self_controller';
application.register('tour-romantic-self', TourRomanticSelfController);

import TourSelfElementController from './tour_self_element_controller';
application.register('tour-self-element', TourSelfElementController);

import TomSelectController from './tom_select_controller';
application.register('tom-select', TomSelectController);

import TypusSelectionController from './typus_selection_controller';
application.register('typus-selection', TypusSelectionController);

import WaitingController from './waiting_controller';
application.register('waiting', WaitingController);

import WikiController from './wiki_controller';
application.register('wiki', WikiController);

import YongShenSearchController from './yong_shen_search_controller';
application.register('yong-shen-search', YongShenSearchController);

// Components

import SwiperComponentController from '../../components/swiper/component_controller';
application.register('swiper--component', SwiperComponentController);

import IntroNewsComponentController from '../../components/intro_news/component_controller';
application.register('intro-news--component', IntroNewsComponentController);

import PdfDownloadComponentController from '../../components/pdf_download/component_controller';
application.register('pdf-download--component', PdfDownloadComponentController);

import AppFlashComponentController from '../../components/app_flash/component_controller';
application.register('app-flash--component', AppFlashComponentController);

import ScrollTopComponentController from '../../components/scroll_top/component_controller';
application.register('scroll-top--component', ScrollTopComponentController);

import CastSearchComponentController from '../../components/cast_search/component_controller';
application.register('cast-search--component', CastSearchComponentController);

import ExpanderComponentController from '../../components/expander/component_controller';
application.register('expander--component', ExpanderComponentController);

import PeopleListComponentController from '../../components/people_list/component_controller';
application.register('people-list--component', PeopleListComponentController);

import ImageUploadComponentController from '../../components/image_upload/component_controller';
application.register('image-upload--component', ImageUploadComponentController);

import LandingPagePricingComponentController from '../../components/landing_page/pricing/component_controller';
application.register(
  'landing-page--pricing--component',
  LandingPagePricingComponentController,
);

import ShareComponentController from '../../components/share/component_controller';
application.register('share--component', ShareComponentController);
